let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6UWQv")).then(() => parcelRequire('4IEkW'));